import { ApolloError, ServerError } from '@apollo/client';
import { getErrorMessage } from '.';

enum ApolloResponseErrorCodes {
  APOLLO_ERR_BAD_USER_INPUT = 'BAD_USER_INPUT'
}

interface ApplicationError {
  code: string;
  message: string;
}

function isApplicationError(error: any): error is ApplicationError {
  return error?.code;
}

function isApolloServerError(error: any): error is ServerError {
  return error?.response && error?.result && error?.statusCode;
}

export function parseErrors(error: ApolloError): string {
  const errors: string[] = [];
  console.log('error is', JSON.parse(JSON.stringify(error)));
  if (error.graphQLErrors) {
    for (const gqlError of error.graphQLErrors) {
      console.log('gqlError is', gqlError);
      if (isApplicationError(gqlError)) {
        errors.push(getErrorMessage(gqlError.code));
      }
    }
  }
  if (error.networkError) {
    const networkError = error.networkError;
    if (isApolloServerError(networkError)) {
      const { result } = networkError;
      const serverErrors = typeof result === 'string' ? [] : result.errors;
      for (const serverError of serverErrors ?? []) {
        if (serverError.extensions?.code === ApolloResponseErrorCodes.APOLLO_ERR_BAD_USER_INPUT) {
          errors.push('Non tutti i campi obbligatori sono stati compilati.')
        }
      }
    }
  }

  if (errors.length === 0) {
    errors.push(`Si è verificato un errore imprevisto. Contattare l'assistenza.`);
  }
  return errors.join(', ');
}